import React, { useEffect } from 'react';

import moment, { Moment } from 'moment';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { loadOrgCriticalDates } from '../critical-dates/actions/load-org-critical-dates';

import { EventDayCard } from './components/event-day-card';

import { CalendarDisplayType } from './utils/calendar-display-type';

type InputProps = {
  orgId: number;
  criticalDatesByDate: { [date: string]: Array<CriticalDate> };
  calendarStart: Moment;
  onMobile: boolean;
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { orgId }: InputProps,
) => ({
  actions: {
    loadOrgCriticalDates: (fromDate: Moment) =>
      dispatch(
        loadOrgCriticalDates(
          orgId,
          moment(fromDate).subtract(15, 'days').format('YYYY-MM-DD'),
          moment(fromDate).add(15, 'days').format('YYYY-MM-DD'),
        ),
      ),
  },
});

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & DispatchProps;

export const EventCalendarPartialWeek = connect(
  null,
  mapDispatchToProps,
)((props: Props) => {
  const { orgId, criticalDatesByDate, calendarStart, onMobile, actions } = props;

  const currentDisplayedDates = [...Array(onMobile ? 3 : 5)].map((_element, i) =>
    moment(calendarStart).add(i, 'days').format('YYYY-MM-DD'),
  );

  useEffect(() => {
    if (
      !criticalDatesByDate ||
      currentDisplayedDates.some((dateString) => !criticalDatesByDate[dateString])
    ) {
      actions.loadOrgCriticalDates(calendarStart);
    }
  });

  return (
    <div className="card-body u-display-flex u-no-padding">
      {currentDisplayedDates.map((dateString, index) => (
        <EventDayCard
          key={dateString}
          orgId={orgId}
          dateString={dateString}
          criticalDates={criticalDatesByDate ? criticalDatesByDate[dateString] : undefined}
          calendarDisplay={CalendarDisplayType.PARTIAL_WEEK}
          className={`${index ? 'u-border-left' : ''}`}
        />
      ))}
    </div>
  );
});
